import { CommonData } from "../types/CommonData";

import Header from "../components/Header";
import { NextPage } from "next";
import { getCommonData } from "../helpers/common-data";
import { getAnnouncements } from "../helpers/getAnnouncements";
import { Announcement } from "../types/Announcement";
import { Spacing } from "../helpers/layout";
import { Wrapper } from "../components/Wrapper";
import { css } from "styled-components";
import { useUserState } from "../context/UserContext";
import { AlreadyAuthenticated } from "../components/AlreadyAuthenticated";
import Footer from "../components/Footer";
import { NotLoggedInForm } from "../components/AccountForm";
import { getFrontendUrl } from "../helpers/utils";
import { SEOTags } from "../components/SEOTags";
import { getRichSnippet } from "../helpers/rich-snippets/static";

export const PageRegister: NextPage<{
  commonData: CommonData;
  announcements: Announcement[];
}> = (props) => {
  const { isAuthenticated } = useUserState();

  const data = {
    title: "Register",
    keywords: "register, website registration",
    description:
      "Register to see prices, compare your favorite prints, save a wishlist, and create scale renderings of how an artwork looks in your space.",
    url: getFrontendUrl(`/register`),
    about: "Sign up for full access to Drew Doggett’s website",
  };

  return (
    <>
      <SEOTags
        title={data.title}
        keywords={data.keywords}
        description={data.description}
        url={data.url}
        richSnippets={getRichSnippet({
          name: data.title,
          slug: "register",
          keywords: data.keywords,
          description: data.description,
          about: data.about,
        })}
      />
      <Header announcements={props.announcements} />
      <div
        css={css`
          margin-top: ${Spacing.xxl};
          padding-bottom: ${Spacing.xxl};
          text-align: center;
        `}
      >
        <Wrapper>
          {!isAuthenticated ? (
            <div
              css={css`
                width: 100%;
                max-width: 600px;
                margin: 0 auto;
              `}
            >
              <NotLoggedInForm />
            </div>
          ) : (
            <div
              css={css`
                margin-bottom: ${Spacing.xxl};
              `}
            >
              <AlreadyAuthenticated />
            </div>
          )}
        </Wrapper>
      </div>
      <Footer />
    </>
  );
};

PageRegister.getInitialProps = async ({ req }) => {
  const commonData = await getCommonData(req);
  const announcements = await getAnnouncements("ALL");
  return {
    commonData: commonData,
    announcements,
  };
};
export default PageRegister;
